import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 3.751a8.25 8.25 0 100 16.499 8.25 8.25 0 100-16.499zm2.583 8.75l-3.712 2.428a.599.599 0 01-.927-.501V9.572a.598.598 0 01.929-.499l-.002-.001 3.713 2.427a.6.6 0 01.002 1.001l-.002.001z"
}), 'PlayVideo');